<script>
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'

import UnionAdminLocalResource from '../resources/unionAdminLocal'
import GridMultiselect from '../components/multiSelectEditor.vue'

export default Vue.extend({
    components: {
        AgGridVue,
    },
    props: {
        rowData: {
            required: false,
            type: Array,
            default: () => {
                return []
            },
        },
    },
    data() {
        return {
            hiredFromStates: [],
            workingInStates: [],
            gridApi: undefined,
            columnApi: undefined,
            unionLocColumnDefs: [
                {
                    field: 'id',
                    headerName: 'ID#',
                    sortable: true,
                    minWidth: 50,
                    maxWidth: 80,
                    valueSetter: () => null,
                    valueGetter: (params) => {
                        return params.data.attributes.id
                    },
                },
                {
                    field: 'union_local_id',
                    headerName: 'union_local_id',
                    sortable: true,
                    editable: true,
                    minWidth: 50,
                    maxWidth: 150,
                    valueSetter: (params) => {
                        this.setUnionLocalId(params)
                    },
                    valueGetter: (params) => {
                        return params.data.get('union_local_id.id')
                    },
                },
                {
                    field: 'union_local_code',
                    headerName: 'union_local_code',
                    sortable: true,
                    editable: true,
                    minWidth: 50,
                    maxWidth: 150,
                    valueSetter: (params) => {
                        let resource = params.data.managers.union_local_id.resource
                        resource.set('code', params.newValue)
                        resource.save()
                    },
                    valueGetter: (params) => {
                        return params.data.get('union_local_id.code')
                    },
                },
                {
                    field: 'union_local_name',
                    headerName: 'Union Name',
                    sortable: true,
                    editable: true,
                    minWidth: 50,
                    maxWidth: 200,
                    valueSetter: (params) => {
                        let resource = params.data.managers.union_local_id.resource
                        resource.set('name', params.newValue)
                        resource.save()
                    },
                    valueGetter: (params) => {
                        return params.data.get('union_local_id.name')
                    },
                },
                {
                    field: 'union_local_description',
                    headerName: 'Union Description',
                    sortable: true,
                    editable: true,
                    minWidth: 50,
                    maxWidth: 200,
                    valueSetter: (params) => {
                        let resource = params.data.managers.union_local_id.resource
                        resource.set('description', params.newValue)
                        resource.save()
                    },
                    valueGetter: (params) => {
                        return params.data.get('union_local_id.description')
                    },
                },
                {
                    field: 'status',
                    headerName: 'status',
                    sortable: true,
                    editable: true,
                    minWidth: 50,
                    maxWidth: 80,
                    valueSetter: (params) => {
                        params.data.set('status', params.newValue)
                        params.data.save()
                    },
                    valueGetter: (params) => {
                        return params.data.attributes.status
                    },
                },
                {
                    field: 'hired_from',
                    headerName: 'hired_from',
                    sortable: true,
                    editable: true,
                    minWidth: 400,
                    valueGetter: (params) => {
                        return params.data.get('hired_from_ids.option_value_code')
                    },
                    cellEditor: 'gridMultiselect',
                    cellEditorPopup: true,
                    cellEditorParams: (params) => {
                        return {
                            values: params.data.get('hired_from_ids'),
                            type: 'option_value',
                        }
                    },
                },
                {
                    field: 'working_in',
                    headerName: 'working_in',
                    sortable: true,
                    editable: true,
                    minWidth: 800,
                    valueGetter: (params) => {
                        return params.data.get('working_in_ids.state_code')
                    },
                    cellEditor: 'gridMultiselect',
                    cellEditorPopup: true,
                    cellEditorParams: (params) => {
                        return {
                            values: params.data.get('working_in_ids'),
                            type: 'state',
                        }
                    },
                },
            ],
            unionLocGridOptions: {
                enterMovesDown: true,
                stopEditingWhenGridLosesFocus: true,
                enterMovesDownAfterEdit: true,
                defaultColDef: {
                    resizable: true,
                    enterMovesDown: true,
                    enterMovesDownAfterEdit: true,
                },
                frameworkComponents: {
                    gridMultiselect: GridMultiselect,
                },
                onGridReady: (params) => {
                    if (params) {
                        this.gridApi = params.api
                        this.columnApi = params.columnApi
                    }
                },
            },
        }
    },
    computed: {
        resources() {
            return {
                UnionAdminLocalResource,
            }
        },
    },
    methods: {
        async setUnionLocalId(params) {
            let res = await UnionAdminLocalResource.detail(params.newValue)
            params.data.set('union_local_id', res.attributes.id)
            params.data.save()
            let manager = params.data.rel('union_local_id')
            await manager.resolve()
            this.unionLocGridOptions.api.refreshCells({ force: true })
        },
    },
})
</script>

<template>
    <div>
        <div><h1>Union Locations Grid</h1></div>
        <div class="clear"></div>
        <ag-grid-vue class="ag-theme-balham default-grid" :grid-options="unionLocGridOptions" :column-defs="unionLocColumnDefs" :row-data="rowData" />
    </div>
</template>

<style>
@import '../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

.default-grid {
    width: 100%;
    height: 200px;
}
</style>
